@if ((isTranslationsLoading$ | async) === false) {
<div id="language-dropdown">
  <div class="language-dropdown-component">
    <mat-icon matIconPrefix class="flag-icon {{ flag }}"></mat-icon>
    <mat-select
      panelClass="custom-dropdown-panel"
      [value]="currentLanguage$ | async"
      placeholder="Select your language"
      (selectionChange)="languageOptionClicked($event.value)"
    >
      @for (language of supportedLanguages; track language) {
      <mat-option value="{{ language }}">{{ language }}</mat-option>
      }
    </mat-select>
  </div>
</div>
}
